import React from 'react';
import { ArrowRight, XCircle, CheckCircle } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-[#F0F4EC]" data-id="element-434">
      <div className="max-w-[700px] mx-auto" data-id="element-435">
        <div className="text-center mb-10" data-id="element-436">
          <h2 className="text-2xl font-bold text-[#B91C1C] mb-4 uppercase tracking-tight flex items-center justify-center gap-2" data-id="element-437">
            ⚠️ Esta Oferta de $6.97 Es Por Tiempo Limitado
          </h2>
          <p className="text-[#5C4A3A] mb-6" data-id="element-438">
            El precio de lanzamiento no durará para siempre. Cuando termine esta
            promoción, el manual vuelve a su precio regular de $149.
          </p>

          {/* Urgency Bar */}
          <div className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm max-w-md mx-auto" data-id="element-439">
            <div className="flex justify-between text-xs font-bold mb-2 uppercase tracking-wider" data-id="element-440">
              <span data-id="element-441">Precio de Lanzamiento</span>
              <span className="text-[#B91C1C]" data-id="element-442">Activo Ahora</span>
            </div>
            <div className="w-full h-4 bg-[#E5E7EB] rounded-full overflow-hidden" data-id="element-443">
              <div className="h-full bg-[#B91C1C] w-[85%] animate-pulse" data-id="element-444"></div>
            </div>
            <p className="text-center text-xs font-bold mt-2 text-[#2C1810]" data-id="element-445">
              ACCESO DIGITAL INMEDIATO POR $6.97
            </p>
          </div>
        </div>

        <h3 className="text-center text-[#2C1810] font-serif font-bold text-2xl mb-8" data-id="element-446">
          Es Tu Momento de Elegir
        </h3>

        <div className="grid grid-cols-1 gap-6 mb-10" data-id="element-447">
          {/* Path A */}
          <div className="bg-white border border-[#E8DFD0] rounded-xl p-6 opacity-70 hover:opacity-100 transition-opacity" data-id="element-448">
            <div className="flex items-center gap-3 mb-4 border-b border-[#E8DFD0] pb-3" data-id="element-449">
              <XCircle className="w-6 h-6 text-[#5C4A3A]" data-id="element-450" />
              <h4 className="text-[#5C4A3A] font-bold text-lg" data-id="element-451">
                CAMINO A: Seguir Igual
              </h4>
            </div>
            <p className="text-[#5C4A3A]" data-id="element-452">
              Más pastillas. Más cansancio. Más respuestas vagas. Más
              sintiéndote "apagado" sin saber por qué.
            </p>
          </div>

          {/* Path B */}
          <div className="bg-white border-2 border-[#2D5A3D] rounded-xl p-6 shadow-green-medium transform scale-[1.02]" data-id="element-453">
            <div className="flex items-center gap-3 mb-4 border-b border-[#2D5A3D]/20 pb-3" data-id="element-454">
              <CheckCircle className="w-6 h-6 text-[#2D5A3D]" data-id="element-455" />
              <h4 className="text-[#2D5A3D] font-bold text-lg" data-id="element-456">
                CAMINO B: Invertir en Tu Salud Natural
              </h4>
            </div>
            <p className="text-[#2C1810] font-medium" data-id="element-457">
              Invertir $6.97 hoy en el sistema que miles de personas ya están
              usando para recuperar su vitalidad, su sueño y su claridad — desde
              su propia cocina. Acceso digital instantáneo.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-458">
          <a href="#comprar" className="inline-flex items-center gap-2 bg-[#2D5A3D] text-white font-bold py-4 px-8 rounded-full hover:bg-[#1B4332] transition-colors shadow-lg" data-id="element-459">
            Elegir el Camino Natural <ArrowRight className="w-4 h-4" data-id="element-460" />
          </a>
        </div>
      </div>
    </section>;
}